import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProGenericModal } from '../office-settings';

@Component({
  selector: 'common-summary-widgets-base',
  templateUrl: './summary-widgets.component.html',
  styleUrls: ['./summary-widgets.component.scss'],
  standalone: false,
})
export class SummaryWidgetsBaseComponent implements OnInit {
  @Input() allWidgets: SummaryWidgetModel[] = [];
  @Output() onClick = new EventEmitter<any>();
  @Input() userSelectedWidget: any;
  @Input() widgetFilterEnum: any;

  selectedWidget: string;

  constructor(private readonly modalService: NgbModal) {}

  ngOnInit() {
    if (this.widgetFilterEnum) {
      this.selectedWidget = this.widgetFilterEnum[this.userSelectedWidget];
    }
  }

  onWidgetClick(widgetId: any) {
    const currentWidget = this.allWidgets?.find(
      (widget) => widget?.type === widgetId,
    );
    if (currentWidget.disabled) {
      const branchesSelectorModal = this.modalService.open(ProGenericModal, {
        centered: true,
      });
      branchesSelectorModal.componentInstance.type = 'SUGGEST-UPGRADE';
      return;
    }
    this.onClick.emit(widgetId);
    this.selectedWidget = widgetId;
  }
}

export interface SummaryWidgetModel {
  title: string;
  description?: string;
  value: number;
  className: string;
  type: any;
  disabled?: boolean;
}
